import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Search } from "lucide-react";
import { CATEGORIES } from "../content/categories";
import { SearchDialog } from "./SearchDialog";

export function SiteNav() {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-rule bg-paper/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-5 py-4">
        <Link to="/" className="group">
          <span
            className="text-2xl font-semibold tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Acadly<span className="text-grade">.</span>in
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {CATEGORIES.map((c) => (
            <Link
              key={c.slug}
              to="/category/$category"
              params={{ category: c.slug }}
              className="index-tab"
              activeProps={{ className: "index-tab index-tab-active" }}
            >
              {c.label}
            </Link>
          ))}
          <Link
            to="/blog"
            className="ml-3 mono-label hover:text-grade transition-colors"
            activeProps={{ className: "ml-3 mono-label text-grade" }}
          >
            All posts →
          </Link>
          <button
            type="button"
            onClick={() => setSearchOpen(true)}
            aria-label="Open search"
            className="ml-3 p-2 text-ink hover:text-grade transition-colors"
          >
            <Search size={18} />
          </button>
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <button
            type="button"
            onClick={() => setSearchOpen(true)}
            aria-label="Open search"
            className="p-2 text-ink hover:text-grade transition-colors"
          >
            <Search size={18} />
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label="Toggle navigation"
            className="mono-label border border-ink px-3 py-1.5"
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-rule bg-paper">
          <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-5 py-4">
            {CATEGORIES.map((c) => (
              <Link
                key={c.slug}
                to="/category/$category"
                params={{ category: c.slug }}
                onClick={() => setOpen(false)}
                className="py-2 border-b border-rule text-lg"
                style={{ fontFamily: "var(--font-display)" }}
              >
                {c.label}
              </Link>
            ))}
            <Link
              to="/blog"
              onClick={() => setOpen(false)}
              className="py-2 mono-label"
            >
              All posts
            </Link>
            <Link
              to="/about"
              onClick={() => setOpen(false)}
              className="py-2 mono-label"
            >
              About
            </Link>
          </nav>
        </div>
      )}

      <style>{`
        .index-tab {
          position: relative;
          padding: 0.5rem 0.9rem;
          font-family: var(--font-display);
          font-size: 0.98rem;
          color: var(--color-ink);
          border-bottom: 2px solid transparent;
          transition: color 0.15s ease, border-color 0.15s ease;
        }
        .index-tab:hover { border-bottom-color: var(--color-grade); }
        .index-tab-active { color: var(--color-grade); border-bottom-color: var(--color-grade); }
      `}</style>
      <SearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>
  );
}